"use client";

import { useState } from "react";

/**
 * 內容縮圖：對照舊站 `!empty($row->image) ? '/' . $row->image : 佔位圖`
 * （見 latest-news/students-sharing/video-reels/monthly-newsletter 的 index.php）。
 * 圖檔實體遷移不在本批範圍內，路徑多半仍會 404——用 onError 掉回佔位框，
 * 避免破圖示。
 */
export function ImageBox({
  src,
  alt,
  className = "",
}: {
  src: string | null;
  alt: string;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    // 第 17 輪一般修正第 4 條：佔位框原本放公司名稱「心成教育」純文字，圖片
    // 大量 404 的清單頁（如 /newsletter）會裸露一串重複字樣、觀感像文字錯位。
    // 改為不含可讀文字的純視覺圖示（山景照片 icon），aria-hidden 維持不讓
    // 螢幕報讀器唸出裝飾內容。
    return (
      <div
        className={`flex items-center justify-center bg-stone-100 text-stone-300 ${className}`}
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-8 w-8"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <circle cx="9" cy="9" r="2" />
          <path d="m21 15-3.5-3.5L9 20" />
        </svg>
      </div>
    );
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element -- 外部/舊站相對路徑圖片，非 next/image 可優化來源
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
    />
  );
}
